export default __webpack_public_path__ + "static/media/mood-ring.84834b0e.png";